import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { update } from '../../actions/userActions';
import { Modal, Button, Form, FormControl, FormGroup, FormLabel, Col, Row } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import UpdateProfileForm from '../UpdateProfileForm'
import { userUpdateProfileReset } from '../../reducers/userReducers';
import { COLORS } from '../../constants/colors';

function UpdateProfileModal({show, onHide, user, deleteModalShow}) {
    // Color constants to match with CreateAddressModal
    const plum = COLORS.PLUM;
    const sageGreen = COLORS.SAGE_GREEN;
    const warmConcrete = COLORS.WARM_CONCRETE;
    const errorColor = COLORS.ERROR;
        
    const [name, setName] = useState(user.name);
    const [email, setEmail] = useState(user.email);
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [message, setMessage] = useState('');

    const dispatch = useDispatch();

    const {
        userReducers: { userUpdateProfileLoading, userUpdateProfileError, userUpdateProfileSuccess }
    } = useSelector((state) => state)

    const validatePassword = (password) => {
        if (password === '') return ''; // Allow empty password (no change)
        
        const minLength = 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumbers = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasNoSpaces = !/\s/.test(password);
        const hasNoCommonPatterns = !/(password|123456|qwerty|admin)/i.test(password);
        
        if (password.length < minLength) {
            return 'Password must be at least 8 characters long';
        }
        if (!hasUpperCase) {
            return 'Password must contain at least one uppercase letter';
        }
        if (!hasLowerCase) {
            return 'Password must contain at least one lowercase letter';
        }
        if (!hasNumbers) {
            return 'Password must contain at least one number';
        }
        if (!hasSpecialChar) {
            return 'Password must contain at least one special character';
        }
        if (!hasNoSpaces) {
            return 'Password cannot contain spaces';
        }
        if (!hasNoCommonPatterns) {
            return 'Password cannot contain common patterns or words';
        }
        
        return '';
    };

    const submitHandler = (e) => {
        e.preventDefault();

        if (password) {
            const passwordError = validatePassword(password);
            if (passwordError) {
                setMessage(passwordError);
                return;
            }

            if (password !== passwordConfirm) {
                setMessage('Passwords do not match!');
                return;
            }
        }

        const newProfile = {
            'id': user._id,
            'name': name,
        }

        if (password) {
            newProfile.password = password;
        }

        const sameEmail = email === user.email

        if(!sameEmail){
            newProfile.email = email
        }

        dispatch(update(newProfile));
    }

    useEffect(() => {
        if(userUpdateProfileSuccess){
            dispatch(userUpdateProfileReset())
            onHide()
        }
    }, [dispatch, onHide, userUpdateProfileSuccess])

    return (
        <Modal show={show} onHide={onHide}>  
            <Modal.Header
                className='border-0'
                closeButton
            />   
            <Col className='d-flex justify-content-center'><h4 style={{ color: plum }}>Edit Profile</h4></Col>
            <Modal.Body>  
                <UpdateProfileForm>
                    {message && <Message variant='danger'>{message}</Message>}
                    {userUpdateProfileError && <Message variant='danger'>{userUpdateProfileError}</Message>}
                    {userUpdateProfileLoading && <Loader />}
                    <Form onSubmit={submitHandler}>
                    <FormGroup controlId='name'>
                        <FormLabel className='my-2 fw-semibold'>Name</FormLabel>
                        <FormControl
                            type='name'
                            placeholder='Enter Full Name'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            >
                        </FormControl>
                    </FormGroup>

                    <FormGroup controlId='email'>
                        <FormLabel className='my-2 fw-semibold'>Email Address</FormLabel>
                        <FormControl
                            type='email'
                            placeholder='Enter Email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            >
                        </FormControl>
                    </FormGroup>

                    <FormGroup controlId='password'>
                        <FormLabel className='my-2 fw-semibold'>Password</FormLabel>
                        <FormControl
                            type='password'
                            placeholder='Enter Password (leave empty to keep current)'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            >
                        </FormControl>
                        <small style={{ fontSize: '0.7em', color: errorColor }}>
                            Password must be at least 8 characters long and contain uppercase, lowercase, numbers, special characters, no spaces, and no common patterns or words.
                        </small>
                    </FormGroup>

                    <FormGroup controlId='passwordConfirm'>
                        <FormLabel className='my-2 fw-semibold'>Confirm Password</FormLabel>
                        <FormControl
                            type='password'
                            placeholder='Confirm Password'
                            value={passwordConfirm}
                            onChange={(e) => setPasswordConfirm(e.target.value)}
                            >
                        </FormControl>
                    </FormGroup>

                    <Row className='d-flex flex-column justify-content-center'>
                        <Col className='d-flex justify-content-center'>
                            <Button 
                                type='submit' 
                                style={{ backgroundColor: sageGreen, borderColor: warmConcrete }}
                                className='my-2 w-100'
                            >
                                Update Profile            
                            </Button>
                        </Col>  
                    </Row>
                    </Form>
                </UpdateProfileForm>
            </Modal.Body>                   
        </Modal> 
    )
}

export default UpdateProfileModal